export const getCurrencySign = jurisdiction => (jurisdiction === 'UK' ? '£' : '$');
